import { Alert } from '@paypalcorp/pp-react-alert'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import Events from '../../../lib/analytics/eventTags'
import { tracking } from '../../../lib/analytics/mParticle'
import { trackImpression } from '../../../lib/analytics/fpti'

/**
 * @callback mandatoryNoteErrorCloseCallback
 * */

/**
 * @typedef {object} NoteFieldMandatoryWarningProps
 * @property {mandatoryNoteErrorCloseCallback} onClose
 * @property {string} noteMandatoryMsg
 * */

/**
 * @param {NoteFieldMandatoryWarningProps} props
 * @returns {JSX.Element}
 * */
const NoteFieldMandatoryError = ({ onClose, noteMandatoryMsg }) => {
  useEffect(() => {
    const pageGroup = 'main:consumer:p2p:note_field_error'
    const pageName = 'main:consumer:p2p:note_field_error::'

    trackImpression(pageGroup, pageName)
    tracking(Events.p2p_amount_story_note_error_occurred({}))

    window.scroll({
      top: 0,
      behavior: 'smooth',
    })
  }, [])

  return (
    <Alert
      data-testid="note-field-mandatory-error"
      type="error"
      closeButton={{
        onClick: onClose,
      }}
      style={{
        maxWidth: '500px',
        margin: '3rem auto 0',
      }}
    >
      {noteMandatoryMsg}
    </Alert>
  )
}

NoteFieldMandatoryError.propTypes = {
  noteMandatoryMsg: PropTypes.string.isRequired,
  onClose: PropTypes.func,
}

export default NoteFieldMandatoryError
